// extracted by mini-css-extract-plugin
export default {"root":"TeamGallery--root--3SeCT","title":"TeamGallery--title--2TsBr","slider--slider":"TeamGallery--slider--slider--2Q_I5"};